import "./Form.css";

const TermsCheckbox = ({ isTermsAccepted, onChange, error }) => {
  return (
    <div className="checkbox">
      <label>
        <input
          type="checkbox"
          id="terms"
          name="terms"
          checked={isTermsAccepted}
          onChange={onChange}
        />
        <span className="icon"></span>
        <div>Ich bin mit den <a href="https://www.onb.ac.at/nutzung" target="_blank">Nutzungsbedingungen</a> einverstanden.</div>
      </label>
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default TermsCheckbox;
